import { dashboardHLTypes } from './actionTypes';

const INIT_STATE = {
  token: "",
  isLoading: false,
  error: {},
};
const DashboardHL = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case dashboardHLTypes.GET_TOKEN_IFRAME:
      return {
        ...state,
        token: "",
        isLoading: true,
      };
    case dashboardHLTypes.GET_GENERIC_TOKEN_IFRAME:
      return {
        ...state,
        token: "",
        isLoading: true,
      };

    case dashboardHLTypes.GET_TOKEN_IFRAME_SUCCESS:
      return {
        ...state,
        token: action.payload,
        isLoading: false,
      };

    case dashboardHLTypes.GET_TOKEN_IFRAME_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default DashboardHL;
